import { Link, useParams } from 'react-router-dom';
import { usePatients } from '../lib/queries';
import { DEMO_PATIENTS } from '../lib/demo-data';
import Spinner from '../components/Spinner';

export default function PatientDetail() {
  const { id } = useParams<{ id: string }>();
  const { data, isLoading } = usePatients();

  if (isLoading) return <Spinner />;

  const fromList = data?.find((p) => p.id === id);
  const demo = DEMO_PATIENTS.find((p) => p.id === id);
  const patient = fromList ?? demo;

  if (!patient) {
    return (
      <div>
        <Link to="/patients" className="small text-decoration-none">
          ‹ Pacientes
        </Link>
        <div className="alert alert-warning mt-3">Paciente não encontrado.</div>
      </div>
    );
  }

  const isDemo = patient.source === 'demo' || !!demo;

  return (
    <div>
      <Link to="/patients" className="small text-muted text-decoration-none">
        <i className="bi bi-arrow-left me-1" />
        Pacientes
      </Link>

      <div className="card shadow-sm mt-3">
        <div className="card-body">
          <div className="d-flex align-items-center gap-3 mb-4">
            <div
              className="rounded-circle d-flex align-items-center justify-content-center bg-success bg-opacity-10"
              style={{ width: 64, height: 64, fontSize: '2rem' }}
            >
              {patient.photo}
            </div>
            <div>
              <h1 className="h4 mb-0">{patient.name}</h1>
              <p className="text-muted small mb-0">{patient.age}</p>
              <p className="small text-muted mb-0">{patient.parents}</p>
            </div>
          </div>

          {patient.alert && (
            <div className="alert alert-danger small">
              <i className="bi bi-exclamation-triangle me-2" />
              Alerta ativo — ver aba Alertas
            </div>
          )}

          <ul className="nav nav-tabs mb-3" role="tablist">
            <li className="nav-item">
              <button className="nav-link active" type="button">
                Resumo
              </button>
            </li>
            <li className="nav-item">
              <button className="nav-link disabled" type="button" title="Em breve">
                Curva
              </button>
            </li>
            <li className="nav-item">
              <button className="nav-link disabled" type="button" title="Em breve">
                Vacinas
              </button>
            </li>
          </ul>

          <div className="row g-3">
            <div className="col-md-6">
              <h2 className="h6">Último registro</h2>
              <p className="text-muted small">
                {isDemo
                  ? 'Dados de demonstração — integração com app família (Expo) após BEB-300.'
                  : 'Família na waitlist — aguardando onboarding no app.'}
              </p>
            </div>
            <div className="col-md-6">
              <h2 className="h6">Próxima consulta</h2>
              <p className="text-muted small mb-0">Ver agenda (demo)</p>
              <Link to="/agenda" className="btn btn-sm btn-outline-success mt-2">
                Abrir agenda
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
